import React from "react";

const Sparkline = ({ data = [], width = 100, height = 32, color }) => {
  if (!data || data.length < 2) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = width / (data.length - 1);
  const points = data
    .map((v, i) => `${(i * stepX).toFixed(2)},${(height - ((v - min) / range) * height).toFixed(2)}`)
    .join(" ");
  const up = data[data.length - 1] >= data[0];
  const strokeColor = color || (up ? "#10b981" : "#ef4444");
  const fillColor = up ? "rgba(16,185,129,0.12)" : "rgba(239,68,68,0.12)";
  const area = `M0,${height} L${points} L${width},${height} Z`;
  return (
    <svg width={width} height={height} className="overflow-visible">
      <path d={area} fill={fillColor} />
      <polyline points={points} fill="none" stroke={strokeColor} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
};

export default Sparkline;
